import React from "react";
import { Link } from "react-router-dom";

const Foot = () => {
  return (
    <>
      <span className="hrfooter"></span>
      <div className="footer-details">
        <div className="text-tiny">
          © All Rights Reserved
          <a href="#" target="_blank">
            <span className="link">
              <strong> Cloudax 2022</strong>
            </span>
          </a>
        </div>
        <div className="footer-nav-links">
          <Link to="/terms" className="nav-link font12">
            {" "}
            Terms Of Use
          </Link>
          <Link to="/privacy" className="nav-link font12">
            {" "}
            Privacy Policy
          </Link>
        </div>
      </div>
    </>
  );
};

export default Foot;
